export function autosize(e, control = null) {
  const target = control ? control : e.currentTarget
  target.style.height = 'auto'
  target.style.height = target.scrollHeight + 10 + 'px'
}
